import { useEffect, useState } from 'react'

import { AlertMessage } from 'reactShared/components/AlertMessage'

import * as S from './styled'
import { ERRORS } from '../../services/constants'

const Error = ({ errors = {} }) => {
  const [keys, setKeyErrors] = useState([])

  useEffect(() => {
    const errorKeys = Object.keys(errors).filter(
      key => !ERRORS.CEP.includes(key) && !ERRORS.SERVICE.includes(key)
    )

    setKeyErrors(errorKeys)
  }, [errors])

  if (!keys.length) {
    return null
  }

  if (!Object.keys(errors).length) {
    return null
  }

  return (
    <S.Wrapper>
      {keys.map(key => {
        const hasNoErrors = !errors?.[key]

        if (hasNoErrors) {
          return null
        }

        return errors[key].map((message, indexMessage) => (
          <AlertMessage
            key={`error-key-message-${indexMessage}`}
            type="critical"
          >
            {message}
          </AlertMessage>
        ))
      })}
    </S.Wrapper>
  )
}

export default Error
